import styled from 'styled-components';
import { spacings } from 'styles';

export const ItemSuggestion = styled.li`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100px;
  position: relative;

  button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      display: flex;
      flex-direction: column;
      strong {
        margin-bottom: ${spacings.space04};
      }
    }
  }
`;

export const Pointer = styled.img`
  width: ${spacings.space05};
`;
